import type { DomainSelectDto, UseSelectDto } from '@@types/api.types';
import { TextWithLabel } from '@components/shared/text-with-label.component';
import type { FunctionComponent } from 'react';

type TechnologyMissionAssessmentRecommendedUsesAndDomainsProps = {
  recommendedDomains: DomainSelectDto[];
  recommendedUses: UseSelectDto[];
};

export const TechnologyMissionAssessmentRecommendedUsesAndDomains: FunctionComponent<
  TechnologyMissionAssessmentRecommendedUsesAndDomainsProps
> = (props) => {
  const { recommendedDomains, recommendedUses } = props;

  const hasData = recommendedUses.length > 0 || recommendedDomains.length > 0;

  if (!hasData) {
    return (
      <div className="mt-6 flex flex-col items-start gap-4 w-full">
        <div className="flex flex-col items-start gap-2 w-full">
          <h3 className="text-base text-gray-700">Recommended Uses and Domains</h3>
          <p className="text-xs text-gray-500">No data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 flex flex-col items-start gap-4 w-full">
      <div className="flex flex-col items-start gap-2 w-full">
        <h3 className="text-base text-gray-700">Recommended Uses and Domains</h3>

        {recommendedUses.length > 0 && (
          <div className="ml-2 flex flex-col items-start gap-2 w-full">
            {recommendedUses.map((use) => (
              <TextWithLabel
                className="text-sm"
                key={use.id}
                label="Use"
                title={use.name}
              />
            ))}
          </div>
        )}

        {recommendedDomains.length > 0 && (
          <div className="ml-2 flex flex-col items-start gap-2 w-full">
            {recommendedDomains.map((domain) => (
              <TextWithLabel
                className="text-sm"
                key={domain.id}
                label="Domain"
                title={domain.name}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
